import FilterGroupFilterCombi from '@/classes/filter-group-filter-combi.model';
import FilterGroup from '@/models/filter-group.model';
import PredefinedFilterItem, { PredefinedFilterItemType } from '@/models/predefined-filter-item.model';

const actions = {
    /**
     * Sets the product sorting
     * @param store - The Vuex store
     * @param productSorting - The sort string
     */
    setProductSorting(store: any, productSorting: string) {
        store.commit("SET_PRODUCT_SORTING", productSorting);
        store.commit("SAVE_STATE");
    },
    /**
     * Selects a filter by the
     * given filterGroupFilterCombi
     * @param store - The Vuex store
     * @param filterGroupFilterCombi - The filterGroup-filter combination
     */
    selectProductFilter(store: any, filterGroupFilterCombi: FilterGroupFilterCombi) {
        const { filterGroup } = filterGroupFilterCombi;

        store.commit("SHOW_INITIAL_PRODUCTS");

        if (filterGroup.type === "single") {
            // unselect all filters from this filter group since the filterGroup is using radio buttons
            // so only one filter can be selected of this filterGroup
            store.commit("UNSELECT_PRODUCT_FILTER_GROUP", filterGroup);
        }

        store.commit("SELECT_PRODUCT_FILTER", filterGroupFilterCombi);
        store.commit("SAVE_STATE");
    },
    /**
     * Unselects a filter by the given
     * filterGroupFilterCombi
     * @param store - The Vuex store
     * @param filterGroupFilterCombi - The filterGroup-filter combination
     */
    unselectProductFilter(store: any, filterGroupFilterCombi: FilterGroupFilterCombi) {
        store.commit("SHOW_INITIAL_PRODUCTS");
        store.commit("UNSELECT_PRODUCT_FILTER", filterGroupFilterCombi);
        store.commit("SAVE_STATE");
    },
    /**
     * Unselect all filters
     * of the given filterGroup
     * @param store - The Vuex store
     * @param filterGroup - The filterGroup
     */
    unselectProductFilterGroup(store: any, filterGroup: FilterGroup) {
        store.commit("SHOW_INITIAL_PRODUCTS");
        store.commit("UNSELECT_PRODUCT_FILTER_GROUP", filterGroup);
        store.commit("SAVE_STATE");
    },
    /**
     * Resets all filters
     * @param store - The Vuex store
     */
    resetProductFilters(store: any) {
        store.commit("RESET_PRODUCT_FILTERS");
        store.commit("SAVE_STATE");
    },
    /**
     * Unselects the given
     * predefined filter item
     */
    unselectPredefinedFilterItem(store: any, predefinedFilterItem: PredefinedFilterItem) {
        switch (predefinedFilterItem.type) {
            default:
                store.commit("UNSELECT_PREDEFINED_FILTER_ITEM", predefinedFilterItem);
                break;
        }
    },
    /**
     * Show more products
     * by incrementing the productLimit
     * @param store - The Vuex store
     */
    showMoreProducts(store: any) {
        store.commit("SHOW_MORE_PRODUCTS");
        store.commit("SAVE_STATE");
    },
    /**
     * Show all products
     * @param store - The Vuex store
     */
     showAllProducts(store: any) {
        store.commit("SHOW_ALL_PRODUCTS");
        store.commit("SAVE_STATE");
    },
};

export default actions;
